/* RTJ · Le configurateur des mariés — comportement
   Le balisage et les textes viennent de sections/rtj-configurateur.liquid ;
   ce fichier ne connaît que le DOM. Il se rejoue quand l'éditeur de thème
   recharge la section. */
(function(){

  function poserConfigurateur(R){
    if (!R || R.dataset.pret) return;
    R.dataset.pret = '1';

    var T = {};
    var blob = R.querySelector('[data-conf-txt]');
    if (blob){ try { T = JSON.parse(blob.textContent) || {}; } catch(e){ T = {}; } }

    var N        = R.querySelectorAll('[data-etape]').length - 1;
    var REMISE   = parseFloat(R.dataset.remise) || 0;
    var REMISEMIN= parseInt(R.dataset.remiseMin, 10) || 2;
    var CMD      = R.dataset.cmd || '/pages/commande';
    var MEMOIRE  = R.dataset.memoire === '1';
    var AW       = (R.dataset.aw || '').trim();
    var SEMAINES = parseInt(R.dataset.delai, 10) || 6;
    var CLE      = R.id;

    var etapes   = R.querySelectorAll('[data-etape]');
    var onglets  = R.querySelectorAll('[data-pas]');
    var resTxt   = R.querySelector('[data-res-txt]');
    var totTxt   = R.querySelector('[data-tot]');
    var btnSuiv  = R.querySelector('[data-suivant]');
    var btnRet   = R.querySelector('[data-retour]');
    var zLignes  = R.querySelector('[data-lignes]');
    var zDetail  = R.querySelector('[data-detail]');
    var lRemise  = R.querySelector('[data-ligne-remise]');
    var vRemise  = R.querySelector('[data-remise-eur]');
    var vTotal   = R.querySelector('[data-total-final]');
    var lien     = R.querySelector('[data-envoi]');
    var champDate= R.querySelector('[data-date]');
    var alerteD  = R.querySelector('[data-date-alerte]');
    var barreRep = R.querySelector('[data-reprise]');

    var LIEN_PIERRE = T.lienPierre;
    var MOT_PIERRE  = T.motPierre;
    var MOT_AJOUT   = T.motAjout;
    var MOT_RETIRE  = T.motRetire;
    var LAB_VES     = T.labVes;
    var MOT_OTER    = T.motOter;

    var choix = new Array(N).fill(null);
    var extras = [];     /* les pièces du vestiaire ajoutées au récapitulatif */
    var pas   = 0;
    var pose  = false;   /* on ne fait défiler la page qu'après le premier clic */
    var restaure = false;/* pendant une reprise, aucun défilement */

    /* Les prix viennent de Liquid en centimes : on ne divise qu'à l'affichage,
       pour ne jamais additionner des arrondis. */
    function euros(c){
      return (c/100).toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' €';
    }
    /* Une pièce du vestiaire compte comme les autres : dans le total, dans
       la remise, dans la demande. Sinon le total baisse moins vite que le
       client ne s'y attend, et un total qui surprend fait reculer. */
    function retenus(){
      return choix.filter(function(x){ return x; }).concat(extras);
    }
    function sousTotal(){
      return retenus().reduce(function(s,x){ return s + x.prix; }, 0);
    }
    /* La remise est arrondie à l'euro entier, sinon le détail et le total
       ne tombent pas juste à l'affichage : 142,50 € s'écrit « 143 € » en
       ligne mais retirerait 142,50 € du total. */
    function remiseEur(){
      if (!REMISE || retenus().length < REMISEMIN) return 0;
      return Math.round(sousTotal() * REMISE / 10000) * 100;
    }
    function total(){ return sousTotal() - remiseEur(); }

    /* ─── le second temps ─────────────────────────────────────────────
       Une rangée par option qui fait varier la pièce. Le prix ne
       s'affiche sur une rangée que si les valeurs ne coûtent pas toutes
       la même chose — sinon on met un prix partout, et le client cherche
       ce qu'il devrait comparer. */
    function lire(b){
      try { return JSON.parse(b.dataset.v || 'null'); } catch(e){ return null; }
    }
    function prixDe(d, sel){
      if (!d || !d.o.length) return null;
      var p = d.c[sel.join(' / ')];
      return (typeof p === 'number') ? p : null;
    }
    function rendSecond(st, i, defiler){
      var zone = st.zone, nomZone = st.nom, rows = st.rows, b = st.b;
      var d = lire(b);
      st.d = d;
      nomZone.textContent = b.dataset.nom;
      rows.innerHTML = '';

      if (!d || !d.o.length){
        zone.hidden = true;
        st.sel = null;
        st.peindre = null;
        poser(i, b, [], parseInt(b.dataset.prix,10) || 0);
        return;
      }

      /* on part de la valeur la moins chère de chaque rangée : le prix
         affiché sur la vignette et le prix du bandeau concordent */
      var sel = d.o.map(function(o){ return o.v[0]; });
      sel = moinsCher(d, sel);

      d.o.forEach(function(o, ri){
        var r = document.createElement('div');
        r.className = 'k2-r';
        var lab = document.createElement('div');
        lab.className = 'k2-lab';
        lab.textContent = o.n;
        r.appendChild(lab);
        var box = document.createElement('div');
        box.className = 'k2-v';
        o.v.forEach(function(val){
          var t = document.createElement('button');
          t.type = 'button';
          t.setAttribute('aria-pressed', String(val === sel[ri]));
          t.dataset.val = val;
          t.dataset.ri  = String(ri);
          box.appendChild(t);
        });
        r.appendChild(box);
        if (o.p && LIEN_PIERRE){
          var a = document.createElement('a');
          a.className = 'k2-a';
          a.href = LIEN_PIERRE;
          a.textContent = MOT_PIERRE;
          r.appendChild(a);
        }
        rows.appendChild(r);
      });

      function peindre(){
        d.o.forEach(function(o, ri){
          var boutons = rows.querySelectorAll('[data-ri="'+ri+'"]');
          /* les prix de cette rangée, les autres choix figés */
          var px = o.v.map(function(val){
            var essai = sel.slice(); essai[ri] = val;
            return prixDe(d, essai);
          });
          var distincts = px.filter(function(p, k){ return p !== null && px.indexOf(p) === k; });
          boutons.forEach(function(t, k){
            t.setAttribute('aria-pressed', String(o.v[k] === sel[ri]));
            t.innerHTML = '';
            t.appendChild(document.createTextNode(o.v[k]));
            if (distincts.length > 1 && px[k] !== null){
              var s = document.createElement('s');
              s.textContent = euros(px[k]);
              t.appendChild(s);
            }
          });
        });
        var p = prixDe(d, sel);
        poser(i, b, sel.slice(), p === null ? (parseInt(b.dataset.prix,10) || 0) : p);
      }

      st.sel = sel;
      st.peindre = peindre;
      peindre();
      zone.hidden = false;

      /* Le bandeau naît sous la grille, souvent hors de l'écran : sans ce
         défilement, le client croit que choisir sa bague n'a rien fait.
         On ne bouge que de ce qu'il faut pour le rendre entièrement
         visible — jamais plus. */
      if (defiler){
        var r = zone.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom > h - 20 || r.top < 0){
          zone.scrollIntoView({behavior:'smooth', block:'nearest'});
        }
      }
    }
    /* la combinaison la moins chère, à partir des valeurs proposées */
    function moinsCher(d, sel){
      var best = sel.slice(), bp = prixDe(d, best);
      Object.keys(d.c).forEach(function(k){
        if (d.c[k] !== null && (bp === null || d.c[k] < bp)){ bp = d.c[k]; best = k.split(' / '); }
      });
      return best;
    }
    function poser(i, b, sel, prix){
      var e = b.closest('[data-etape]');
      var titre = e ? e.querySelector('.k-h') : null;
      choix[i] = {
        nom  : b.dataset.nom,
        prix : prix,
        img  : b.dataset.img || '',
        url  : b.dataset.url || '',
        etape: titre ? titre.textContent.trim() : '',
        opts : sel,
        detail: sel.length ? sel.join(' · ') : (titre ? titre.textContent.trim() : '')
      };
    }

    /* ─── le vestiaire ────────────────────────────────────────────────
       Une pièce du vestiaire ne se configure pas ici : elle hérite de ce
       qui a déjà été choisi. Si la bague est en synthétique et en or
       jaune, les puces le sont aussi — c'est exactement ce que promet le
       texte au-dessus, et ça évite un troisième niveau de choix. */
    function heritage(){
      var v = [];
      choix.forEach(function(x){
        if (x && x.opts) x.opts.forEach(function(o){ if (v.indexOf(o) < 0) v.push(o); });
      });
      return v;
    }
    function selArticle(d){
      if (!d || !d.o.length) return [];
      var sel = moinsCher(d, d.o.map(function(o){ return o.v[0]; }));
      var h = heritage();
      /* On parcourt l'héritage dans l'ordre de la composition, pas dans
         l'ordre des valeurs de l'option : sur une commande panachée, c'est
         la bague de fiançailles qui donne le ton, pas la première case. */
      d.o.forEach(function(o, ri){
        for (var k = 0; k < h.length; k++){
          if (o.v.indexOf(h[k]) >= 0){ sel[ri] = h[k]; break; }
        }
      });
      /* si l'héritage donne une combinaison qui n'existe pas, on garde la
         moins chère plutôt que d'afficher un prix faux */
      return (prixDe(d, sel) === null) ? moinsCher(d, sel) : sel;
    }
    function majArticles(){
      R.querySelectorAll('.k-art').forEach(function(b){
        var d = lire(b);
        var sel = selArticle(d);
        var p = prixDe(d, sel);
        if (p === null) p = parseInt(b.dataset.prix, 10) || 0;
        var dedans = -1;
        extras.forEach(function(x, k){ if (x.nom === b.dataset.nom) dedans = k; });

        var px = b.querySelector('[data-art-prix]');
        var mot = b.querySelector('[data-art-mot]');
        if (px) px.textContent = euros(p);
        if (mot) mot.textContent = (dedans >= 0) ? MOT_RETIRE : MOT_AJOUT;
        b.setAttribute('aria-pressed', dedans >= 0 ? 'true' : 'false');

        /* la pièce déjà retenue suit l'héritage : changer la pierre de la
           bague change celle des boucles, sans y toucher */
        if (dedans >= 0){
          extras[dedans].prix = p;
          extras[dedans].opts = sel;
          extras[dedans].detail = sel.length ? sel.join(' · ') : LAB_VES;
        }
      });
    }

    function majBarre(){
      var r = retenus();
      resTxt.textContent = r.length ? r.map(function(x){ return x.nom; }).join(' · ')
                                    : (pas < N ? T.rienChoisi : '—');
      totTxt.textContent = r.length ? euros(total()) : '—';
      btnRet.hidden  = (pas === 0);
      btnSuiv.hidden = (pas === N);
      btnSuiv.textContent = (pas >= N - 1)
        ? T.voirRecap
        : T.suivant;
      majOnglets();
    }

    function majOnglets(){
      onglets.forEach(function(o){
        var i = parseInt(o.dataset.pas, 10);
        o.removeAttribute('data-on');
        o.removeAttribute('data-fait');
        o.removeAttribute('aria-current');
        /* « fait » veut dire qu'une pièce y est retenue, pas qu'on y est
           passé : avec une navigation libre, l'ordre ne prouve rien. */
        if (i === pas){ o.setAttribute('data-on',''); o.setAttribute('aria-current','step'); }
        else if (i < N && choix[i]) o.setAttribute('data-fait','');
      });
    }

    function montre(i){
      pas = Math.max(0, Math.min(N, i));
      etapes.forEach(function(e){ e.hidden = (parseInt(e.dataset.etape,10) !== pas); });
      majBarre();
      if (pas === N) recap();
      /* Sur téléphone et tablette, on ramène le fil des étapes en haut de
         l'écran : sinon on change d'étape sans voir laquelle. Sur ordinateur
         la page ne bouge pas — tout tient déjà sous les yeux. */
      var fil = R.querySelector('.k-pas');
      if (pose && fil && window.innerWidth <= 1020){
        fil.style.scrollMarginTop = '90px';
        if (fil.getBoundingClientRect().top < 0){
          fil.scrollIntoView({behavior:'smooth', block:'start'});
        }
      }
      /* Et on centre l'étape courante dans le fil lui-même, qui défile
         horizontalement quand les intitulés ne tiennent pas dans la largeur. */
      if (fil && fil.scrollWidth > fil.clientWidth + 4){
        var ong = fil.querySelector('[data-pas="' + pas + '"]');
        if (ong){
          var rf = fil.getBoundingClientRect(), ro = ong.getBoundingClientRect();
          fil.scrollTo({
            left: fil.scrollLeft + (ro.left - rf.left) - (rf.width - ro.width) / 2,
            behavior: 'smooth'
          });
        }
      }
      pose = true;
      garder();
    }

    function recap(){
      majArticles();
      var r = retenus();
      zLignes.innerHTML = '';
      zDetail.innerHTML = '';

      if (!r.length){
        zLignes.innerHTML = '<p class="k-vide-msg">' +
          T.recapVide +
          '</p>';
      }

      choix.forEach(function(x, i){
        if (!x) return;
        var l = document.createElement('div');
        l.className = 'k-lig';
        l.innerHTML =
          '<span class="v">' + (x.img ? '<img src="'+x.img+'" alt="">' : '') + '</span>' +
          '<span class="t"><b></b><span></span></span>' +
          '<span class="p"><span class="px"></span><button type="button">' +
            T.modifier +
          '</button></span>';
        l.querySelector('.t b').textContent = x.nom;
        l.querySelector('.t span').textContent = x.detail || x.etape;
        l.querySelector('.px').textContent = euros(x.prix);
        l.querySelector('button').addEventListener('click', function(){ montre(i); });
        zLignes.appendChild(l);

        var d = document.createElement('div');
        d.className = 'l';
        d.innerHTML = '<span></span><b></b>';
        d.querySelector('span').textContent = x.etape;
        d.querySelector('b').textContent = euros(x.prix);
        zDetail.appendChild(d);
      });

      /* les pièces du vestiaire, sous les autres, avec « Retirer » plutôt
         que « Modifier » : elles ne renvoient à aucune étape */
      extras.forEach(function(x){
        var l = document.createElement('div');
        l.className = 'k-lig';
        l.innerHTML =
          '<span class="v">' + (x.img ? '<img src="'+x.img+'" alt="">' : '') + '</span>' +
          '<span class="t"><b></b><span></span></span>' +
          '<span class="p"><span class="px"></span><button type="button"></button></span>';
        l.querySelector('.t b').textContent = x.nom;
        l.querySelector('.t span').textContent = x.detail || LAB_VES;
        l.querySelector('.px').textContent = euros(x.prix);
        var bt = l.querySelector('button');
        bt.textContent = MOT_OTER;
        bt.addEventListener('click', function(){ oter(x.nom); });
        zLignes.appendChild(l);

        var d = document.createElement('div');
        d.className = 'l';
        d.innerHTML = '<span></span><b></b>';
        d.querySelector('span').textContent = LAB_VES;
        d.querySelector('b').textContent = euros(x.prix);
        zDetail.appendChild(d);
      });

      var rem = remiseEur();
      lRemise.hidden = (rem === 0);
      if (rem) vRemise.textContent = '− ' + euros(rem);
      vTotal.textContent = r.length ? euros(total()) : '—';

      /* La composition part sur la page de demande : « piece » porte le
         résumé, « configuration » le détail. rtj-commande lit déjà ces
         deux paramètres, rien à y changer. */
      var titres = r.map(function(x){
        return x.opts && x.opts.length ? x.nom + ' (' + x.opts.join(' / ') + ')' : x.nom;
      });
      var resume = titres.length
        ? T.resume + ' — ' + titres.length + (titres.length > 1 ? ' pièces' : ' pièce')
        : T.resume;
      var url = CMD +
        '?piece=' + encodeURIComponent(resume) +
        '&configuration=' + encodeURIComponent(titres.join(' · '));
      if (champDate && champDate.value) url += '&date=' + encodeURIComponent(champDate.value);
      lien.href = url;
    }

    /* ─── la date du mariage ─────────────────────────────────────────── */
    if (champDate){
      var demain = new Date(Date.now() + 86400000);
      champDate.min = demain.toISOString().slice(0,10);
      champDate.addEventListener('change', function(){
        var court = false;
        if (champDate.value){
          var j = (new Date(champDate.value) - new Date()) / 86400000;
          court = (j < SEMAINES * 7);
        }
        if (alerteD) alerteD.hidden = !court;
        recap();
        garder();
      });
    }

    /* ─── la conversion ───────────────────────────────────────────────
       Un seul endroit où l'on déclare qu'une demande est partie. Sans
       ça, Google Ads dépense sans jamais savoir ce qui a marché. */
    function conversion(){
      var v = total() / 100;
      var pieces = retenus().map(function(x){ return x.nom; });
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'rtj_composition',
          value: v, currency: 'EUR',
          pieces: pieces, nombre: pieces.length
        });
      } catch(e){}
      try {
        if (AW && typeof window.gtag === 'function'){
          window.gtag('event', 'conversion', { send_to: AW, value: v, currency: 'EUR' });
        }
      } catch(e){}
      try {
        if (typeof window.fbq === 'function'){
          window.fbq('track', 'Lead', { value: v, currency: 'EUR', content_name: 'Composition mariés' });
        }
      } catch(e){}
    }
    lien.addEventListener('click', function(){ conversion(); });

    /* ─── la mémoire du navigateur ────────────────────────────────────
       Une composition se réfléchit à deux et sur plusieurs jours. On la
       garde trente jours sur l'appareil — rien ne part ailleurs. */
    function garder(){
      if (!MEMOIRE) return;
      try {
        var etat = {t: Date.now(), pas: pas, choix: choix, extras: extras,
                    date: champDate ? champDate.value : ''};
        localStorage.setItem(CLE, JSON.stringify(etat));
      } catch(e){}
    }
    function relire(){
      if (!MEMOIRE) return null;
      try {
        var e = JSON.parse(localStorage.getItem(CLE) || 'null');
        if (!e || !e.choix) return null;
        if (Date.now() - e.t > 30*86400000) return null;
        if (!e.extras) e.extras = [];
        if (!e.choix.filter(function(x){ return x; }).length && !e.extras.length) return null;
        return e;
      } catch(err){ return null; }
    }
    function oublier(){ try { localStorage.removeItem(CLE); } catch(e){} }

    function reprendre(e){
      restaure = true;
      e.choix.forEach(function(x, i){
        if (!x) return;
        var et = R.querySelector('[data-etape="'+i+'"]');
        if (!et) return;
        var b = null;
        et.querySelectorAll('.k-c').forEach(function(c){
          if (c.dataset.nom === x.nom) b = c;
        });
        if (!b) return;
        b.click();
        /* on repose les options exactes d'alors ; le prix se recalcule
           tout seul à partir des variantes, jamais depuis la mémoire —
           un tarif a pu changer entre-temps */
        var st = etats[i];
        if (st && st.sel && x.opts && x.opts.length){
          x.opts.forEach(function(val, ri){
            st.rows.querySelectorAll('[data-ri="'+ri+'"]').forEach(function(t){
              if (t.dataset.val === val) t.click();
            });
          });
        }
      });
      /* on remet les pièces du vestiaire par leur nom, jamais par leur
         prix : celui-ci est recalculé depuis les variantes du jour */
      (e.extras || []).forEach(function(x){
        var b = null;
        R.querySelectorAll('.k-art').forEach(function(c){
          if (c.dataset.nom === x.nom) b = c;
        });
        if (b && !extras.some(function(y){ return y.nom === x.nom; })) b.click();
      });
      if (champDate && e.date){ champDate.value = e.date; champDate.dispatchEvent(new Event('change')); }
      restaure = false;
      montre(Math.min(e.pas || 0, N));
    }

    /* choisir, ou déchoisir en recliquant */
    var etats = {};
    etapes.forEach(function(e){
      var i = parseInt(e.dataset.etape, 10);
      if (i >= N) return;
      var st = {
        zone: e.querySelector('[data-second]'),
        nom : e.querySelector('[data-second-nom]'),
        rows: e.querySelector('[data-second-rows]'),
        b   : null, d: null, sel: null, peindre: null
      };
      etats[i] = st;

      /* un seul écouteur par étape, posé une fois : le bandeau se
         reconstruit à chaque pièce, pas les écouteurs */
      if (st.rows) st.rows.addEventListener('click', function(ev){
        var t = ev.target.closest ? ev.target.closest('button[data-ri]') : null;
        if (!t || !st.sel || !st.peindre) return;
        st.sel[parseInt(t.dataset.ri, 10)] = t.dataset.val;
        st.peindre();
        majBarre();
        garder();
      });

      e.querySelectorAll('.k-c').forEach(function(b){
        b.addEventListener('click', function(){
          var deja = (b.getAttribute('aria-pressed') === 'true');
          e.querySelectorAll('.k-c').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          if (deja){
            choix[i] = null;
            st.b = null; st.sel = null; st.peindre = null;
            if (st.zone) st.zone.hidden = true;
          } else {
            b.setAttribute('aria-pressed','true');
            st.b = b;
            if (st.zone) rendSecond(st, i, !restaure);
            else poser(i, b, [], parseInt(b.dataset.prix,10) || 0);
          }
          majBarre();
          garder();
        });
      });
      var saut = e.querySelector('[data-saut]');
      if (saut) saut.addEventListener('click', function(){
        e.querySelectorAll('.k-c').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        st.b = null; st.sel = null; st.peindre = null;
        if (st.zone) st.zone.hidden = true;
        choix[i] = null;
        montre(i + 1);
      });
    });

    /* ─── ajouter, retirer une pièce du vestiaire ─────────────────── */
    function oter(nom){
      extras = extras.filter(function(x){ return x.nom !== nom; });
      majArticles();
      majBarre();
      recap();
      garder();
    }
    R.querySelectorAll('.k-art').forEach(function(b){
      b.addEventListener('click', function(){
        var dedans = extras.some(function(x){ return x.nom === b.dataset.nom; });
        if (dedans){ oter(b.dataset.nom); return; }
        var d = lire(b);
        var sel = selArticle(d);
        var p = prixDe(d, sel);
        if (p === null) p = parseInt(b.dataset.prix, 10) || 0;
        extras.push({
          nom  : b.dataset.nom,
          prix : p,
          img  : b.dataset.img || '',
          url  : b.dataset.url || '',
          etape: LAB_VES,
          opts : sel,
          detail: sel.length ? sel.join(' · ') : LAB_VES
        });
        majArticles();
        majBarre();
        recap();
        garder();
      });
    });

    /* ─── sortir du bandeau sans redescendre ──────────────────────── */
    R.querySelectorAll('[data-suivant2]').forEach(function(b){
      var i = parseInt(b.dataset.suivant2, 10);
      b.textContent = (i >= N - 1)
        ? T.voirRecap
        : T.suivant;
      b.addEventListener('click', function(){ montre(i + 1); });
    });

    btnSuiv.addEventListener('click', function(){ montre(pas + 1); });
    btnRet .addEventListener('click', function(){ montre(pas - 1); });
    /* Le fil est une vraie navigation : on va et vient entre les
       fiançailles, les alliances et le récapitulatif dans n'importe quel
       ordre. Rien n'est obligatoire, donc rien ne doit être verrouillé. */
    onglets.forEach(function(o){
      o.addEventListener('click', function(){
        montre(parseInt(o.dataset.pas, 10));
      });
    });

    /* On relit AVANT le premier affichage : montre(0) enregistre l'état
       courant, et écraserait la composition gardée avant qu'on l'ait vue. */
    var garde = relire();

    montre(0);

    if (garde && barreRep){
      barreRep.hidden = false;
      barreRep.querySelector('[data-reprendre]').addEventListener('click', function(){
        barreRep.hidden = true; reprendre(garde);
      });
      barreRep.querySelector('[data-oublier]').addEventListener('click', function(){
        barreRep.hidden = true; oublier();
      });
    }
  }

  function tout(racine){
    (racine || document).querySelectorAll('[data-conf]').forEach(poserConfigurateur);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ tout(); });
  } else {
    tout();
  }
  document.addEventListener('shopify:section:load', function(e){ tout(e.target); });
})();